import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { StatusDashboard } from '../statusDashboard';

export const getStatusDashboardRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    statusDashboard: {
      path: `${basePath}/status-dashboard`,
      url: `${baseUrl}/status-dashboard`,
      documentTitle: 'Status Dashboard',
    },
  };
};

export const getStatusDashboardRoutes = (basePath: string, baseUrl: string) => {
  const config = getStatusDashboardRoutesConfig(basePath, baseUrl);
  return {
    statusDashboard: (
      <Route exact path={config.statusDashboard.path}>
        <Page routeDefinition={config.statusDashboard}>
          <StatusDashboard />
        </Page>
      </Route>
    ),
  };
};
